// extracted by mini-css-extract-plugin
module.exports = {"switcher":"Switch_switcher__2mVTM","label":"Switch_label__aIzk0","container":"Switch_container__28q2c"};